import { Document, Font } from '@react-pdf/renderer'
import isEmpty from 'lodash/isEmpty'
import { useRef } from 'react'
import CoverPage from './Pages/Course/CoverPage'
import DisclaimerPage from './Pages/Course/DisclaimerPage'
import TableOfContentsPage from './Pages/Course/TableOfContentsPage'
import Chapter1Page from './Pages/Course/Chapter1Page'
import AttachmentPage from './Pages/Course/AttachmentPage'

Font.register({
  family: 'Noto Sans',
  fonts: [
    { src: `${process.env.PUBLIC_URL}/fonts/NotoSansTC-Regular.ttf` },
    { src: `${process.env.PUBLIC_URL}/fonts/NotoSansTC-Bold.ttf`, fontWeight: 700 },
  ],
})

Font.registerHyphenationCallback(word => Array.from(word).flatMap(char => [char, '']))

const CourseReportDocument = ({ pageData = {}, reportData, onRender }) => {
  const localPageData = useRef(pageData)

  const setPage = page => {
    if (isEmpty(pageData)) {
      const prevData = localPageData.current
      localPageData.current = { ...prevData, ...page }
    }
  }

  return (
    <Document
      style={{ wordBreak: 'break-all' }}
      onRender={() => {
        onRender?.({ pageData: localPageData.current })
      }}
    >
      <CoverPage reportData={reportData} />
      <DisclaimerPage reportData={reportData} />
      <TableOfContentsPage pageData={pageData} reportData={reportData} />
      <Chapter1Page setPage={setPage} reportData={reportData} />
      <AttachmentPage setPage={setPage} reportData={reportData} />
    </Document>
  )
}

export default CourseReportDocument
